var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('iframe',{attrs:{"src":_vm.videoEmbedLink,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }